$(() => {
    if (!formPredata) {
        return
    }
    $.each(formPredata.ids, function (k, v) {
        cleanForm($('#' + v))
    })

    $.each(formPredata.predata, function (k, v) {
        $('#' + k).val(v)
    })

    $.each(formPredata.submitIds, function (k, v) {
        $('#' + v).submit()
    })
})
